import { render, staticRenderFns } from "./EmailNotifications.vue?vue&type=template&id=3b57d226&"
import script from "./EmailNotifications.vue?vue&type=script&lang=js&"
export * from "./EmailNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports